module.exports = __webpack_public_path__ + "static/media/KEAAdvertising_Logo.e6f4aa61.jpg";